<script>
  import { ContactScreen } from '../../../module_core/module_contact'
</script>

<svelte:head>
  <title>Faça seu orçamento com preço fixo e escopo fechado.</title>

  <meta
    title="description"
    content="Conte-nos sobre o seu projeto de software, aplicativo, sistema web ou site. Nossa equipe analisa e retorna com uma proposta técnica e comercial personalizada, geralmente em até 24 horas. "
  />

  <!-- Primary Meta Tags -->

  <!-- Open Graph / Facebook -->
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://lutruvials.com/" />
  <meta property="og:title" content="Faça seu orçamento com preço fixo e escopo fechado." />
  <meta property="og:site_name" content="lutruvials" />
  <!-- prettier-ignore -->
  <meta property="og:description" content={'Conte-nos sobre o seu projeto de software, aplicativo, sistema web ou site. Nossa equipe analisa e retorna com uma proposta técnica e comercial personalizada, geralmente em até 24 horas. '} />
  <meta property="og:image" content="/jpeg/hero-banner.jpg" />

  <!-- X (Twitter) -->
  <meta property="twitter:card" content="/jpeg/hero-banner.jpg" />
  <meta property="twitter:url" content="https://lutruvials.com/" />
  <meta property="twitter:title" content="Faça seu orçamento com preço fixo e escopo fechado." />
  <meta
    property="twitter:description"
    content={'Conte-nos sobre o seu projeto de software, aplicativo, sistema web ou site. Nossa equipe analisa e retorna com uma proposta técnica e comercial personalizada, geralmente em até 24 horas. '}
  />
  <meta property="twitter:image" content="/jpeg/hero-banner.jpg" />
</svelte:head>

<ContactScreen />
